<div class="product-manager-dialog-container">
    <div class="modal-header">
        <h3 class="modal-title" id="modal-basic-title">Manage Products: {{ mapName }}</h3>
    </div>
    <div class="modal-subtitle">This module allows you to add products to the map and automatically create nodes for them</div>

    <div class="product-manager-body mt-3">
        <div class="d-flex justify-content-between">
            <div class="product-manager-card existing-products mr-5">
                <h3 class="product-card-title">On Map ({{productsOnMap.length}})</h3>
                <div class="product-card-list">
                    <div *ngIf="productsLoading" class="fa fa-spinner fa-spin"></div>
                    <div *ngFor="let product of productsOnMap | orderBy:productNameCaseInsensitiveOrder" class="product-list-row">
                        <div>
                            <div class="bold">{{ product.name }}</div>
                            <div *ngIf="product.companyNames?.length > 0" class="product-list-company">{{ product.companyNames | join }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-manager-card new-products">
                <h3 class="product-card-title">Not On Map ({{productsNotOnMap?.length + ignoredProducts?.length}})</h3>
                <div class="product-card-list">
                    <div *ngIf="productsLoading">
                        <div class="fa fa-spinner fa-spin"></div>
                        <ng-container *ngIf="showLoadingMessage">(May take up to a minute to load all products for large maps)</ng-container>
                    </div>
                    <div *ngIf="productsNotOnMap?.length > 0" class="product-manager-search-container form-group">
                        <input type="text" class="product-manager-search-input form-control" id="product-search"
                               name="product-search" placeholder="Search..." (input)="searchProductList($event.target['value'])" />
                    </div>
                    <div *ngFor="let product of filteredNewProducts | orderBy:productNameCaseInsensitiveOrder; let i = index" class="product-list-row" [ngClass]="{ 'end-border': i === filteredNewProducts.length - 1 && filteredIgnoredProducts.length > 0 }">
                        <div class="d-flex">
                            <div *ngIf="product.mapStatuses && product.mapStatuses[mapsManagerVersion.mapsManagerId] && product.mapStatuses[mapsManagerVersion.mapsManagerId] !== 'IGNORED'"
                                 class="product-list-label mr-4"
                                 [ngClass]="product.mapStatuses[mapsManagerVersion.mapsManagerId] | lowercase">
                                {{ product.mapStatuses[mapsManagerVersion.mapsManagerId] }}
                            </div>
                            <div>
                                <div class="bold">{{ product.name }}</div>
                                <div *ngIf="product.companyNames?.length > 0" class="product-list-company">{{ product.companyNames | join }}</div>
                                <div *ngIf="product.changes">
                                    <div *ngFor="let change of product.changes | keyvalue" class="updated-text">
                                        <span class="green-italics mr-2">Updated</span> {{ change.value[0] }} to {{ change.value[1] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex product-list-button-container">
                            <img src="assets/icons/maps-manager/product-manager/read.svg" alt="Ignore" class="mr-2 icon" ngbTooltip="Click to acknowledge" tooltipClass="product-list-tooltip"
                                 (click)="ignoreProduct(product)" />
                            <img src="assets/icons/maps-manager/product-manager/plus.svg" alt="Add To Map" class="icon" ngbTooltip="Click to add to map" tooltipClass="product-list-tooltip"
                                 (click)="addProduct(product)"/>
                        </div>
                    </div>

                    <div *ngIf="filteredIgnoredProducts?.length > 0" class="ignored-products-container">
                        <div *ngFor="let product of filteredIgnoredProducts | orderBy:productNameCaseInsensitiveOrder" class="product-list-row">
                            <div>
                                <div class="bold">{{ product.name }}</div>
                                <div *ngIf="product.companyNames?.length > 0" class="product-list-company">{{ product.companyNames | join }}</div>
                            </div>

                            <div class="d-flex product-list-button-container">
                                <img src="assets/icons/maps-manager/product-manager/read.svg" alt="Acknowledge" class="mr-2 icon" ngbTooltip="Click to acknowledge" tooltipClass="product-list-tooltip"
                                     (click)="ignoreProduct(product)" />
                                <img src="assets/icons/maps-manager/product-manager/plus.svg" alt="Add To Map" class="icon" ngbTooltip="Click to add to map" tooltipClass="product-list-tooltip"
                                     (click)="addProduct(product)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="product-manager-card added-products mt-4">
            <h3 class="product-card-title">Add To Map ({{productsToAddToMap.length}})</h3>
            <div class="product-card-list">
                <div *ngIf="productsToAddToMap.length === 0" class="product-list-row no-products">No products to add</div>
                <div *ngFor="let product of productsToAddToMap | orderBy:'name'" class="product-list-row">
                    <div>
                        <div class="bold">{{ product.name }}</div>
                        <div *ngIf="product.companyNames?.length > 0" class="product-list-company">{{ product.companyNames | join }}</div>
                    </div>
                    <div class="product-list-button-container">
                        <div class="icon remove-product" (click)="removeProduct(product)">X</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer d-flex mt-3">
        <button type="button" class="btn border" (click)="close()">Close</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</div>
